import jsPDF from 'jspdf';
import logo3 from './LOGOS/LOGO1.png'; 
import logo1 from './LOGOS/LOGO2.png';
import logo2 from './LOGOS/LOGO3.png'; 
import logo4 from './LOGOS/CONTIGO.png';

// Función auxiliar para cargar imágenes de forma asíncrona
const loadImage = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = url;
  });
};

export const generateCertificate = async (userData) => {
  try {
    // Crear nueva instancia de jsPDF
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4'
    });

    // Configurar colores
    const blueColor = [0, 51, 102]; // Azul fuerte
    const pinkColor = [255, 105, 180]; // Rosado
    const textColor = [44, 62, 80]; // Gris oscuro

    // Agregar borde azul de 50 mm en el lado izquierdo
    const borderWidth = 50; // 50 mm
    doc.setFillColor(...blueColor);
    doc.rect(0, 0, borderWidth, 210, 'F'); // Rectángulo que cubre toda la altura

    // Calcular el centro del área de contenido
    const pageWidth = 297; 
    const contentWidth = pageWidth - borderWidth; // Ancho disponible para el contenido
    const contentCenter = borderWidth + (contentWidth / 2); // Centro del área de contenido: 173.5 mm

    const logo1Width = 40; 
    const logo1Height = 15; 
    const logo2Width = 50; 
    const logo2Height = 15; 
    const logo3Width = 35; 
    const logo3Height = 15; 

    const logoSpacing = 15;

    // Calcular el ancho total que ocuparán todos los logos
    const totalLogosWidth = logo1Width + logo2Width + logo3Width + (logoSpacing * 2);

    // Calcular la posición X inicial para centrar todos los logos
    const startX = contentCenter - (totalLogosWidth / 2);

    try {
      // Logo 1 - Con dimensiones corregidas para evitar distorsión
      const logo1Img = await loadImage(logo1);
      doc.addImage(logo1Img, 'PNG', startX, 10, logo1Width, logo1Height);
      
      // Logo 2
      const logo2Img = await loadImage(logo3);
      doc.addImage(logo2Img, 'PNG', startX + logo1Width + logoSpacing, 10, logo2Width, logo2Height);
      
      // Logo 3
      const logo3Img = await loadImage(logo2);
      doc.addImage(logo3Img, 'PNG', startX + logo1Width + logo2Width + (logoSpacing * 2), 10, logo3Width, logo3Height);
      
      // Logo 4 en la esquina inferior izquierda
      const logo4Width = 80; 
      const logo4Height = 80;
      const logo4Img = await loadImage(logo4);
      doc.addImage(logo4Img, 'PNG', 10, 210 - logo4Height - 10, logo4Width, logo4Height);
      
    } catch (error) {
      console.error('Error al cargar los logos:', error);
    }

    // Texto introductorio
    doc.setFontSize(12);
    doc.setTextColor(...textColor);
    doc.text('La Secretaría de Educación del Poder Ejecutivo del Estado de Querétaro otorga la presente', contentCenter, 40, { align: 'center' });

    // Título "CONSTANCIA" más grande y en negritas
    doc.setFontSize(36);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...pinkColor);
    doc.text('CONSTANCIA', contentCenter, 60, { align: 'center' });

    // Nombre del usuario
    doc.setFontSize(18);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...textColor);
    const nombreCompleto = `${userData.nombre} ${userData.apellido_paterno} ${userData.apellido_materno}`;
    doc.text(nombreCompleto, contentCenter, 80, { align: 'center' });

    // Línea debajo del nombre
    const nombreWidth = doc.getTextWidth(nombreCompleto);
    const nombreX = contentCenter - (nombreWidth / 2);
    const nombreY = 80;
    const lineY = nombreY + 5; // 5 mm debajo del nombre
    doc.setLineWidth(0.5);
    doc.line(nombreX, lineY, nombreX + nombreWidth, lineY);

    // Texto "Por haber terminado:"
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text('Por haber terminado el programa:', contentCenter, 95, { align: 'center' });

    // Texto "CONTIGO TU CARRERA UNIVERSITARIA" en negritas
    doc.setFont('helvetica', 'bold');
    doc.text('"CONTIGO TU CARRERA UNIVERSITARIA"', contentCenter, 100, { align: 'center' });

    // Texto "Con el perfil profesional:"
    doc.setFont('helvetica', 'normal');
    doc.text('Con el perfil profesional:', contentCenter, 110, { align: 'center' });

    // Resultados - Perfil profesional en negritas
    doc.setFontSize(12);
    let currentY = 125; // Aumentamos el espaciado inicial (era 120)
    
    if (userData.resultadoTest2) {
      const nombreAreaLimpio = limpiarNombreArea(userData.resultadoTest2.ar_nombre);
      doc.setFont('helvetica', 'bold'); // Establecer negritas para el perfil profesional
      doc.text(nombreAreaLimpio, contentCenter, currentY, { align: 'center' });
      currentY += 20; // Aumentamos el espaciado después del perfil profesional (era 10)
    }
    
    if (userData.resultadoTest3) {
      doc.setFont('helvetica', 'normal'); // Volver a fuente normal
      doc.text(userData.resultadoTest3.ar_descripcion, contentCenter, currentY, { align: 'center' });
      currentY += 20; // Aumentamos el espaciado antes de la leyenda (era 15)
    }

    // Leyenda sobre el instrumento CHASIDE
    doc.setFontSize(9); // Reducimos el tamaño de fuente (era 12)
    doc.setFont('helvetica', 'normal');
    
    // Dividir el texto de la leyenda en varias líneas para mejor legibilidad
    const leyendaTexto = [
      'Este resultado ha sido obtenido mediante la aplicación del instrumento CHASIDE',
      '(Checklist de Habilidades Sociales para la Inclusión y el Desarrollo Educativo),',
      'diseñado para evaluar competencias socioemocionales en contextos educativos.'
    ];
    
    leyendaTexto.forEach((linea, index) => {
      doc.text(linea, contentCenter, currentY + (index * 5), { align: 'center' });
    });

    // Ajustar la posición de la fecha para que no se superponga
    currentY += 25; // Espacio después de la leyenda

    // Fecha
    const fechaActual = new Date().toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    doc.setFontSize(11);
    doc.setTextColor(...textColor);
    doc.text(`Otorgado el ${fechaActual}`, contentCenter, Math.max(currentY, 185), { align: 'center' });

    // Generar el archivo PDF
    const pdfBlob = doc.output('blob');
    const url = window.URL.createObjectURL(pdfBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `certificado_${userData.nombre}_${userData.apellido_paterno}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error('Error generando certificado:', error);
    throw error;
  }
};

// Función para limpiar nombres de áreas
const limpiarNombreArea = (nombre) => {
  if (!nombre) return 'Área no disponible';
  return nombre
    .replace(/├ü/g, 'Á')
    .replace(/├ó/g, 'á')
    .replace(/├ë/g, 'É')
    .replace(/├⌐/g, 'é')
    .replace(/├ì/g, 'Í')
    .replace(/├¡/g, 'í')
    .replace(/├ô/g, 'Ó')
    .replace(/├│/g, 'ó')
    .replace(/├Ü/g, 'Ú')
    .replace(/├║/g, 'ú')
    .replace(/├æ/g, 'Ñ')
    .replace(/├▒/g, 'ñ');
};

// NUEVA FUNCIÓN: Genera el certificado en Base64 (silenciosamente) para mandarlo por correo
export const generarCertificadoBase64 = async (userData) => {
  try {
    const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
    const blueColor = [0, 51, 102];
    const pinkColor = [255, 105, 180];
    const textColor = [44, 62, 80];
    const borderWidth = 50;
    
    doc.setFillColor(...blueColor);
    doc.rect(0, 0, borderWidth, 210, 'F');

    const pageWidth = 297; 
    const contentWidth = pageWidth - borderWidth;
    const contentCenter = borderWidth + (contentWidth / 2);
    
    // --- Lógica de logos ---
    const logo1Width = 40, logo1Height = 15; 
    const logo2Width = 50, logo2Height = 15; 
    const logo3Width = 35, logo3Height = 15; 
    const logoSpacing = 15;
    const totalLogosWidth = logo1Width + logo2Width + logo3Width + (logoSpacing * 2);
    const startX = contentCenter - (totalLogosWidth / 2);

    try {
      const logo1Img = await loadImage(logo1);
      doc.addImage(logo1Img, 'PNG', startX, 10, logo1Width, logo1Height);
      const logo2Img = await loadImage(logo3);
      doc.addImage(logo2Img, 'PNG', startX + logo1Width + logoSpacing, 10, logo2Width, logo2Height);
      const logo3Img = await loadImage(logo2);
      doc.addImage(logo3Img, 'PNG', startX + logo1Width + logo2Width + (logoSpacing * 2), 10, logo3Width, logo3Height);
      const logo4Img = await loadImage(logo4);
      doc.addImage(logo4Img, 'PNG', 10, 210 - 80 - 10, 80, 80);
    } catch (error) {
      console.warn('Advertencia: No se cargaron los logos para el PDF en Base64', error);
    }

    // --- Textos ---
    doc.setFontSize(12);
    doc.setTextColor(...textColor);
    doc.text('La Secretaría de Educación del Poder Ejecutivo del Estado de Querétaro otorga la presente', contentCenter, 40, { align: 'center' });

    doc.setFontSize(36);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...pinkColor);
    doc.text('CONSTANCIA', contentCenter, 60, { align: 'center' });

    doc.setFontSize(18);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(...textColor);
    const nombreCompleto = `${userData.nombre || ''} ${userData.apellido_paterno || ''} ${userData.apellido_materno || ''}`.trim();
    doc.text(nombreCompleto, contentCenter, 80, { align: 'center' });

    const nombreWidth = doc.getTextWidth(nombreCompleto) || 50;
    const nombreX = contentCenter - (nombreWidth / 2);
    doc.setLineWidth(0.5);
    doc.line(nombreX, 85, nombreX + nombreWidth, 85);

    doc.setFontSize(12);
    doc.text('Por haber terminado el programa:', contentCenter, 95, { align: 'center' });
    doc.setFont('helvetica', 'bold');
    doc.text('"CONTIGO TU CARRERA UNIVERSITARIA"', contentCenter, 100, { align: 'center' });
    doc.setFont('helvetica', 'normal');
    doc.text('Con el perfil profesional:', contentCenter, 110, { align: 'center' });

    let currentY = 125;
    if (userData.resultadoTest2) {
      doc.setFont('helvetica', 'bold');
      doc.text(limpiarNombreArea(userData.resultadoTest2.ar_nombre), contentCenter, currentY, { align: 'center' });
      currentY += 20;
    }

    if (userData.resultadoTest3) {
      doc.setFont('helvetica', 'normal');
      doc.text(userData.resultadoTest3.ar_descripcion, contentCenter, currentY, { align: 'center' });
      currentY += 20;
    }

    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    ['Este resultado ha sido obtenido mediante la aplicación del instrumento CHASIDE',
     '(Checklist de Habilidades Sociales para la Inclusión y el Desarrollo Educativo),',
     'diseñado para evaluar competencias socioemocionales en contextos educativos.'
    ].forEach((linea, index) => {
      doc.text(linea, contentCenter, currentY + (index * 5), { align: 'center' });
    });

    currentY += 25;
    const fechaActual = new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' });
    doc.setFontSize(11);
    doc.text(`Otorgado el ${fechaActual}`, contentCenter, Math.max(currentY, 185), { align: 'center' });

    // LA MAGIA: Devolver como Base64 en lugar de descargar
    return doc.output('datauristring');

  } catch (error) {
    console.error('Error generando certificado Base64:', error);
    return null;
  }
};